"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _Modal = _interopRequireWildcard(require("../Modal"));
var _styles = require("./styles");
var _keydownEvents = require("../utils/keydown-events");
var _excluded = ["header", "onClose", "closeAriaLabel"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ModalWithoutContentPadding = (0, _styledComponents["default"])(_Modal["default"]).withConfig({
  displayName: "ModalWithHeader__ModalWithoutContentPadding",
  componentId: "sc-rglt0z-0"
})(["", "{padding:0;}"], _Modal.ContentWrapper);
var ModalWithHeader = function ModalWithHeader(_ref) {
  var header = _ref.header,
    onClose = _ref.onClose,
    closeAriaLabel = _ref.closeAriaLabel,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var headerContent;
  if ((0, _isFunction["default"])(header)) {
    headerContent = header();
  } else if ((0, _isString["default"])(header)) {
    headerContent = /*#__PURE__*/_react["default"].createElement("h2", null, header);
  } else {
    headerContent = header;
  }
  var onEnterKeyDown = (0, _keydownEvents.createOnEnterKeyDown)(onClose);
  var head = /*#__PURE__*/_react["default"].createElement(_styles.Header, {
    bordered: Boolean(headerContent)
    // for basic (string/empty) headers only
    ,
    centered: !headerContent || (0, _isString["default"])(header)
  }, /*#__PURE__*/_react["default"].createElement(_styles.HeadingCol, null, headerContent), /*#__PURE__*/_react["default"].createElement(_styles.CloseCol, {
    tabIndex: "0",
    onKeyDown: onEnterKeyDown,
    "aria-label": closeAriaLabel
  }, /*#__PURE__*/_react["default"].createElement(_styles.CloseIcon, {
    onClick: onClose
  })));
  return /*#__PURE__*/_react["default"].createElement(ModalWithoutContentPadding, (0, _extends2["default"])({
    headerChildren: head,
    onClose: onClose
  }, rest));
};
ModalWithHeader.propTypes = {
  header: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  className: _propTypes["default"].string,
  onClose: _propTypes["default"].func.isRequired,
  closeOnOverlayClick: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(['sm', 'md', 'lg', 'xl', 'custom']),
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  closeAriaLabel: _propTypes["default"].string
};
ModalWithHeader.defaultProps = {
  header: null,
  className: '',
  closeOnOverlayClick: true,
  size: 'md',
  width: null,
  height: null,
  closeAriaLabel: 'Close'
};
var _default = ModalWithHeader;
exports["default"] = _default;
//# sourceMappingURL=ModalWithHeader.js.map